<template>
  <div class="shop-filters-container">
    <div class="toggle-shop-filters">
      <div data-toggle="collapse" class="filterBtn collapsed btn" data-target="#filterOptions">
        Filter By
      </div>
    </div>

    <div id="filterOptions" class="collapse">
      <ul class="filter-list">
        <filter-header v-for="filterHeader in filterHeaders" :key="filterHeader.name.replace(' ', '_')"
          :filter-header="filterHeader" />
        <li v-if="displayFilterOptions">
          <a href="/shop/cerakote-coating?finishes=cera_equipment" class="filter-list-title" style="background: none;">Equipment <i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
        </li>
        <!-- <li v-if="displayFilterOptions">
          <a href="/shop/cerakote-collections" class="filter-list-title" style="background: none;">View Collections</a>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FilterHeader from "./FilterHeader";

export default {
  name: "filter-options",

  props: {
    displayFilterOptions: Boolean,
    hasSelectedParentCollection: Boolean
  },

  components: {
    FilterHeader
  },

  data() {
    return {
      filterHeaders: this.reorderFiltersByCode('cera_series', 'cera_fx', 'cera_cure', '...rest'),
    }
  },

  computed: {
    ...mapGetters([
      'selectedCollectionCategory',
      'selectedFilterOptions'
    ]),
  },

  methods: {

    /**
     * @method reorderFiltersByCode
     * @created August 30th, 2024
     * @author Sebastian Inman <sinman@nicindustries.com>
     * @description Reorders the shop filters by the `code` property.
     * @param {Array} order - The order in which the filters should be displayed.
     * @returns Array
     */
    reorderFiltersByCode(...order) {

      // Cerakote filters with the "cera_collections" filter removed.
      const filters = Object.values(window._PR?.filterOptions).filter(header => header.code !== 'cera_collections');

      // Extract the manually specified elements and remove them from the array.
      const manualOrder = order.filter(item => typeof item === 'string');
      const manuallyPlaced = manualOrder.map(code => {
        const index = filters.findIndex(filter => filter.code === code);
        return filters.splice(index, 1)[0];
      })

      // Generate the final ordered array.
      const finalOrder = order.map(item => {
        if (typeof item === 'string') {
          return manuallyPlaced.shift(); // Place manually set objects.
        } else if (item === '...rest') {
          return filters.shift(); // Place remaining objects.
        }
      })

      // In case there are leftover elements that weren't placed.
      return finalOrder.concat(filters);

    }

  },

  mounted() {
    if (Object.keys(this.selectedCollectionCategory)) return;

    const parentCategoryName = Object.values(this.selectedCollectionCategory.parent_category_refs.map(item => item.name.toLowerCase()));

    if (this.selectedFilterOptions.length && this.selectedCollectionCategory.code === this.selectedFilterOptions[0].code) {
      this.filterHeaders = [];
    }

    if (parentCategoryName.includes('collections') && this.selectedCollectionCategory.sub_categories.length) {
      this.filterHeaders = [this.selectedCollectionCategory]
    }
  },

  watch: {
    selectedFilterOptions() {
      // resets the filter to "default" values
      if (this.selectedFilterOptions.length === 0) {
        this.filterHeaders = Object.values(window._PR?.filterOptions).filter(header => header.code !== 'cera_collections');
      }

      // prevents rendering filters if it is a child collection
      if (this.selectedFilterOptions.length && this.selectedCollectionCategory.code === this.selectedFilterOptions[0].code) {
        this.filterHeaders = [];
      }
    },
  },
}
</script>
